import { render, staticRenderFns } from "./fine.vue?vue&type=template&id=d0061652&scoped=true"
import script from "./fine.vue?vue&type=script&lang=js"
export * from "./fine.vue?vue&type=script&lang=js"
import style0 from "./fine.vue?vue&type=style&index=0&id=d0061652&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0061652",
  null
  
)

export default component.exports